import React, { Component } from 'react';
import { Modal, message,Button,DatePicker } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import format from '../../shared/format';
import moment from 'moment';
import TableC from '../../basicElement/TableC';

const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Filter extends Component {

    state = {

        searchParams: {
            dateStart:moment().format('YYYY-MM'),
            dateEnd:moment().format('YYYY-MM'),
        },
        operable:true
    }

    componentDidMount() {

    }

    setFilterParams=(params)=>{
        const{searchParams}=this.state;
        this.setState({
           searchParams:{
               ...searchParams,
               ...params
           }
        })
    }

    search = () => {
        const { searchParams } = this.state;
        const params = {
            ...searchParams,
        };

        this.props.search(params);
    }

    export = () => {
        const { searchParams } = this.state;
        const params = {
            ...searchParams,
        };

        this.props.export(params);
    }



    changeSearchParams = (params) => {
        const { searchParams } = this.state;
        this.setState({ searchParams: { ...searchParams, ...params } });
    }

    handleDateChange = (data, dateString, key) => {
        const { searchParams: { dateStart, dateEnd } } = this.state;
        if (key === 'dateStart') {
            if (dateEnd) {
                if (moment(dateString).valueOf() > moment(dateEnd).valueOf()) {
                    this.changeSearchParams({
                        dateStart: dateEnd,
                        dateEnd: dateString,
                    });
                    return;
                } 
                // else if (moment(dateString).valueOf() === moment(dateEnd).valueOf()) {
                //     message.warning('不能选择单月！');
                //     return;
                // }
            }
            this.changeSearchParams({ [key]: dateString });
        } else if (key === 'dateEnd') {
            if (dateStart) {
                if (moment(dateString).valueOf() < moment(dateStart).valueOf()) {
                    this.changeSearchParams({
                        dateStart: dateString,
                        dateEnd: dateStart,
                    });
                    return;
                }
                //  else if (moment(dateString).valueOf() === moment(dateStart).valueOf()) {
                //     message.warning('不能选择单月！');
                //     return;
                // }
            }
            this.changeSearchParams({ [key]: dateString });
        } else {
            this.changeSearchParams({ [key]: dateString });
        }  
    }

    render() {
        const { searchParams,operable } = this.state;
        const { dateStart,dateEnd } = searchParams;
        const newdateStart = dateStart ? moment(dateStart) : null;
        const newdateEnd = dateEnd ? moment(dateEnd) : null;
        return (
            <div className="filter-wrap" style={{ padding: 10, background: '#fff',display:"flex" }}>
                    <div >
                            <span style={{marginRight: 15}}>统计月份</span>
                            <MonthPicker
                                value={newdateStart}
                                format={monthFormat}
                                placeholder="请选择"
                                style={{width: 120, verticalAlign: 'middle'}}
                                allowClear={false}
                                onChange={(date, dateString) => this.handleDateChange(date, dateString, 'dateStart')}
                            />
                            <span style={{ marginLeft: 10, marginRight: 10 }}>至</span>
                            <MonthPicker
                                value={newdateEnd}
                                format={monthFormat}
                                placeholder="请选择"
                                allowClear={false}
                                style={{width: 120, verticalAlign: 'middle'}}
                                onChange={(date, dateString) => this.handleDateChange(date, dateString, 'dateEnd')}
                            />
                        </div>
            <div className="filter-item" style={{marginLeft:"15px"}}>
                <Button type="primary" onClick={this.search}>搜索</Button>
            </div>
            <div className="filter-item" style={{marginLeft:"15px"}}>
            <Button type="primary" disabled={!operable} onClick={this.export}>导出</Button>
            </div>
        </div>
        )
    }
}


class PercentCompletionChangeLog extends React.Component {
    state = {
        visible: false,
        loading: false,
        searchParams:{
            dateStart:moment().format('YYYY-MM'),
            dateEnd:moment().format('YYYY-MM'),
        },
        sortParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        data: [],
    }

    show = () => {
        this.setState({
            visible: true,
        }, () => {
            this.queryFixedLineTime();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    // componentDidMount() {
    //     this.queryFixedLineTime();
    // }
    setFilterParams=()=>{
        const{searchParams}=this.state;
        this.filterRef.setFilterParams(searchParams);
    }

    queryFixedLineTime = () => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.common.queryFixedLineTime,
            data: {

            },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const { searchParams } = this.state;
                const dateStart = moment(format('month', data[0].year, data[0].month)).format('YYYY-MM');
                const dateEnd = moment(format('month', data[data.length - 1].year, data[data.length - 1].month)).format('YYYY-MM');
                searchParams.dateStart = dateStart;
                searchParams.dateEnd = dateEnd;
                this.setState({
                    searchParams,
                }, () => {
                    this.loadData();
                    this.setFilterParams()
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const columns = [{
            title: '统计月份',
            dataIndex: 'yearMonthShow',
            key: 'yearMonthShow',
            fixed: 'left',
            width: 100,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            fixed: 'left',
            width: 120,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 120,
        }, {
            title: '变更时间',
            dataIndex: 'changeTime',
            key: 'changeTime',
            width: 100,
        }, {
            title: 'JDE项目号',
            dataIndex: 'jdeCode',
            key: 'jdeCode',
            width: 250,
        }
        , {
            title: '变更内容',
            dataIndex: 'changeContent',
            key: 'changeContent',
            width: 120,
        }, {
            title: '变更前',
            dataIndex: 'beforeChange',
            key: 'beforeChange',
            width: 100,
        }
        , {
            title: '变更后',
            dataIndex: 'afterChange',
            key: 'afterChange',
            width: 100,
        }
        , {
            title: '操作人',
            dataIndex: 'userCompellationShow',
            key: 'userCompellationShow',
            width: 100,
        }
        , {
            title: '完工百分比是否重跑',
            dataIndex: 'isFinishPresentRerecordShow',
            key: 'isFinishPresentRerecordShow',
            width: 100,
        },{
            title: '重跑时间',
            dataIndex: 'finishPresentRerecordTime',
            key: 'finishPresentRerecordTime',
            width: 100,
        }
        , {
            title: '财务收入报告是否重跑',
            dataIndex: 'isJdeRerecordShow',
            key: 'isJdeRerecordShow',
            width: 100,
        }
        , {
            title: '重跑时间',
            dataIndex: 'jdeRerecordTime',
            key: 'jdeRerecordTime',
            width: 100,
        }
        ]
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: {...params},
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams } = this.state;
        const url = API_URL.common.exportFinishPresentChangeLog;
        ExportUtil.export({ ...sortParams, ...searchParams }, null, url);
    }

    loadData = () => {
        const { pagination,searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.common.queryFinishPresentChangeLog,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                this.setState({
                    pagination,
                    loading: false,
                    data:datas,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { data,visible, loading, searchParams,sortParams,pagination } = this.state;
        return (
            <Modal
                title="完工百分比变更日志"
                visible={visible}
                onCancel={this.hide}
                width={1200}
                loading={loading}
                footer={[
                    <Button key="back" size="large" onClick={this.hide}>关闭</Button>,
                ]}
                bodyStyle={{maxHeight:620}}
            >
                <Filter
                    search={this.search}
                    params={searchParams}
                    export={this.export}
                    ref={el => this.filterRef = el}
                />
                <TableC
                    data={data}
                    loading={loading}
                    rowKey="id"
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                    scrollY={400}
                />
            </Modal>
        );
    }
}

export default PercentCompletionChangeLog;


// WEBPACK FOOTER //
// ./src/components/sumTotal/proPercent/PercentCompletionChangeLog.js